// @flow
import React from 'react'
import style from './Footer.css'
type footerProps = {
  src: {
    text: string,
    href?: string,
    datasetHref?: string
  }
}

const Footer = ({ src }: footerProps) => {
  const { text, href, datasetHref } = src
  if (!text) {
    return <footer className={style.footer} />
  }

  return (
    <footer className={style.footer}>
      <Source text={text} href={href} />
      <DownloadLink datasetHref={datasetHref} />
    </footer>
  )
}

export let Source = ({ text, href }: { text: string, href?: string }) => {
  if (!href) return <div>Kilde: {text}</div>
  return (
    <div>
      Kilde: <a href={href}>{text}</a>
    </div>
  )
}

export let DownloadLink = ({ datasetHref }: { datasetHref?: string }) => {
  if (!datasetHref) return null
  return (
    <div>
      <a href={datasetHref}>Last ned datasett</a>
    </div>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/shared/components/Footer/Footer.js